import React from 'react';

const Textarea = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  placeholder,
  required = false,
  disabled = false,
  hint,
  rows = 4,
  className = '',
  ...props
}) => {
  const hasError = error && touched;

  const textareaClasses = [
    'w-full rounded-lg border bg-white text-sm text-ink-900 placeholder-ink-400 px-3.5 py-2.5',
    'transition-shadow duration-150 resize-y',
    'focus:outline-none focus:ring-4',
    hasError
      ? 'border-rose-400 focus:border-rose-500 focus:ring-rose-100'
      : 'border-ink-200 hover:border-ink-300 focus:border-brand-500 focus:ring-brand-100',
    disabled ? 'bg-ink-50 text-ink-500 cursor-not-allowed' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="space-y-1.5">
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-ink-700"
        >
          {label}
          {required && <span className="text-rose-500 ml-0.5">*</span>}
        </label>
      )}

      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={textareaClasses}
        {...props}
      />

      {hasError ? (
        <p className="text-xs text-rose-600">{error}</p>
      ) : hint ? (
        <p className="text-xs text-ink-500">{hint}</p>
      ) : null}
    </div>
  );
};

export default Textarea;
